export const LeavePayoutPayTypes = {
	BONUS: 'BONUS',
	ANNLEAVE: 'ANNLEAVE',
	SUMMERPAY: 'Summer Pay'
};
